/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { candidateSchema } from './candidate-schema';
import { clientRequestSchema } from './client-request-schema';
import { contactSchema } from './contact-schema';

export const calendarManualInterviewRequestSchema: z.AnyZodObject = z.object({
  adhocEmail: z.string().nullish(),
  adhocFirstName: z.string().nullish(),
  adhocLastName: z.string().nullish(),
  availabilityNote: z.string().nullish(),
  candidate: z.lazy(() => candidateSchema).nullish(),
  candidateId: z.string().uuid().nullish(),
  clientRequest: z.lazy(() => clientRequestSchema).nullish(),
  clientRequestId: z.string().uuid().nullish(),
  contact: z.lazy(() => contactSchema).nullish(),
  contactId: z.string().uuid().nullish(),
  createdAt: z.string().datetime().nullish(),
  id: z.string().uuid(),
  updatedAt: z.string().datetime().nullish(),
});

export type CalendarManualInterviewRequest = z.infer<typeof calendarManualInterviewRequestSchema>;
